import { isAxiosError } from 'axios'
import { walletAPI } from "../API/walletConfig"
import { errorHandler } from "../globalHeader/functions/ams-functions"
import { BonusAmount, BonusType, DailyBonus } from "./bonusTypes"

// errorHandler drops the HTTP status; callers classify on it (0 = no response)
const walletError = (error: unknown) => ({
    ...errorHandler(error),
    status: (isAxiosError(error) && error.response?.status) || 0,
})

export const getBonusForUser = async (userId: string, bonusType: BonusType): Promise<DailyBonus> => {
    try {
        const response = await walletAPI.get(`/api/players/${userId}/bonuses/${bonusType}`)
        return response.data
    } catch (error) {
        throw walletError(error)
    }
}

export const claimBonusForUser = async (userId: string, bonusType: BonusType): Promise<{ amount: number }> => {
    try {
        const response = await walletAPI.post(`/api/players/${userId}/bonuses/${bonusType}`)
        return response.data
    } catch (error) {
        throw walletError(error)
    }
}

export const getBonusAdditionalInfo = async (bonusType: BonusType): Promise<Array<BonusAmount>> => {
    try {
        const response = await walletAPI.get(`/api/bonuses/${bonusType}`)
        return response.data
    } catch (error) {
        throw walletError(error)
    }
}